 import * as React from 'react';

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import SwipeableViews from 'react-swipeable-views';

import AppBar from '@material-ui/core/AppBar';

import Tabs from '@material-ui/core/Tabs';

import Tab from '@material-ui/core/Tab';

import Typography from '@material-ui/core/Typography';

import { Button, Card, Col, Icon, Row } from 'react-materialize';

import TextField from '@material-ui/core/TextField';

import { Input, FormGroup, Label } from 'reactstrap';

import Radio from '@material-ui/core/Radio';

// styling
import './TabView.css';

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';

// Demo styles, see 'Styles' section below for some notes on use.
import 'react-accessible-accordion/dist/fancy-example.css';
import CustomCheckbox from 'src/common/CustomCheckbox';


function TabContainer({ children, dir }) {
  return (
    <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '95%',
  },
});


class FullWidthTabs extends React.Component<any> {
  public state = {
    introtext: this.props.introtext,
    value: 0,
  };

  constructor (props) {
    super(props);
    this.state = {
      introtext: this.props.introtext,
      value: 0,
    };
    this.handleDragAdd = this.handleDragAdd.bind(this);
    this.selectionChanges = this.selectionChanges.bind(this);
    this.handleAnswerAdd = this.handleAnswerAdd.bind(this);
  }

  public handleDragAdd() {
    this.props.dragadd();
    console.log('update req');
    this.forceUpdate();
  }

  public handleAnswerAdd() {
    this.props.choiceadd();
    console.log('update choice');
    this.forceUpdate();
  }

  public selectionChanges (e) {
    console.log('change:' + e.target.checked);
    this.props.selectionchange(e.target.checked);
    this.forceUpdate();
    console.log('updated:' + this.props.newchoicecorrect);
  }

  public handleChange = (event, value) => {
    this.setState({ value });
  };

  public handleChangeIndex = index => {
    this.setState({ value: index });
  };

  public dynamicOptions() {
    if(this.props.interactiontype === '1') {
      return (
        //   <div>
        //   <p>Introductory Text </p>

        //   <Card className='grey lighten-5' textClassName='blue-text' title=''>
        //     <input  height="10" data-arg='introtext' onChange={this.props.inputchange} name="introtext" placeholder={this.props.intro}
        //     />
        //   </Card>

        //   <p>Completion Text</p>
        //   <Card className='grey lighten-5' textClassName='blue-text' title=''>
        //     <input data-arg='completiontext' onChange={this.props.inputchange} name="completiontext" placeholder={this.props.completiontext}
        //     />
        //   </Card>
        //   <p>Button text</p>
        //     <Card className='grey lighten-5' textClassName='blue-text' title=''>
        //     <input data-arg='buttontext' onChange={this.props.inputchange} name="buttontext" placeholder={this.props.buttontext}
        //     />
        //   </Card>

        //   <p>Question</p>
        //   <Card className='grey lighten-5' textClassName='blue-text' title=''>
        //     <input data-arg='question' onChange={this.props.inputchange} name="question" placeholder={this.props.question} />
        //   </Card>

        //   <p>Answers(Redwords)</p>
        //   <Card className='grey lighten-5' textClassName='blue-text' title=''>
        //     <input data-arg='redwords' onChange={this.props.inputchange} name="redwords"  placeholder={this.props.redwords}/>
        //   </Card>
        // </div>
        <div className="tabview-container">
          <p className="interaction-input-title">Introductory Text</p>
          <div className="card-item">
            <input
              className="interaction-input"
              height="10"
              data-arg="introtext"
              onChange={this.props.inputchange}
              name="introtext"
              placeholder={this.props.intro}
            />
          </div>

          <p className="interaction-input-title">Completion Text</p>
          <div
            className="card-item"
            // textClassName="blue-text"
            // title=""
          >
            <input
            className="interaction-input"
              data-arg="completiontext"
              onChange={this.props.inputchange}
              name="completiontext"
              placeholder={this.props.completiontext}
            />
          </div>
          <p className="interaction-input-title">Button text</p>
          <div
            className="card-item"
            // textClassName="blue-text"
            // title=""
          >
            <input
            className ="interaction-input"
              data-arg="buttontext"
              onChange={this.props.inputchange}
              name="buttontext"
              placeholder={this.props.buttontext}
            />
          </div>

          <p className="interaction-input-title">Question</p>
          <div
            className="card-item"
            // textClassName="blue-text"
            // title=""
          >
            <input
            className = "interaction-input"
              data-arg="question"
              onChange={this.props.inputchange}
              name="question"
              placeholder={this.props.question}
            />
          </div>

          <p className="interaction-input-title">Answers(Redwords)</p>
          <div
            className="card-item"
            // textClassName="blue-text"
            // title=""
          >
            <input
            className="interaction-input"
              data-arg="redwords"
              onChange={this.props.inputchange}
              name="redwords"
              placeholder={this.props.redwords}
            />
          </div>
        </div>
      );
    }
    else if(this.props.interactiontype === '2') {
      return(
        <div>

        <p className="interaction-input-title">Introductory Text </p> 
        <div className='card-item'>
          <input className="interaction-input" height="10" data-arg='introtext' onChange={this.props.inputchange} name="introtext" placeholder={this.props.intro}
          />
        </div>

        <p className="interaction-input-title">Completion Text</p>
        <div className='card-item'>
          <input className="interaction-input" data-arg='completiontext' onChange={this.props.inputchange} name="completiontext" placeholder={this.props.completiontext}
          />
        </div>

        <p className="interaction-input-title">Questions</p>
        
        <p className="interaction-input-title">Add new Question</p>
        <div className='card-item-large'>
          <input className="interaction-input" data-arg='newdrag' onChange={this.props.inputchange} name="newdrag" placeholder={this.props.newdrag}
          />
          <input className="interaction-input" data-arg='newdrop' onChange={this.props.inputchange} name="newdrop" placeholder={this.props.newdrop}
          />
          <input className="interaction-input" data-arg='newdragcompletiontext' onChange={this.props.inputchange} name="newdragcompletiontext" placeholder={this.props.newdragcompletiontext}
          />
          <button className="green-button add-interaction" onClick={this.handleDragAdd}>Add</button> 
        </div>

        <p className="interaction-input-title">Questions List</p>
        <div className='card-item-large'>
        <Accordion style={{width: "100%"}}>
          {this.props.dragquestions.map((question, idx) => <AccordionItem key={idx} className='upcoming-activity'>
         
         <AccordionItemHeading>
                    <AccordionItemButton>
                      <p style={{marginBottom: '3px'}}>{question.drag}</p>
                    </AccordionItemButton>
         </AccordionItemHeading>

         <AccordionItemPanel>
          <p style={{color: 'green'}}>{question.drop}</p>
         </AccordionItemPanel>

         <AccordionItemPanel>
          <p style={{color: 'green'}}>{question.completion}</p>
         </AccordionItemPanel>

         </AccordionItem>)}
         </Accordion>
        </div>
          
        
 

        </div>
      );
    }
    else if(this.props.interactiontype === '3' || this.props.interactiontype === '4') {
      return(
        <div>
        <p className="interaction-input-title">Introductory Text </p>
 
        <div className="card-item">
          <input className="interaction-input"  height="10" data-arg='introtext' onChange={this.props.inputchange} name="introtext" placeholder={this.props.intro}
          />
        </div>

        <p className="interaction-input-title">Completion Text</p>
        <div className="card-item">
          <input className="interaction-input" data-arg='completiontext' onChange={this.props.inputchange} name="completiontext" placeholder={this.props.completiontext}
          />
        </div>

        <p className="interaction-input-title">Question</p>
        <div className="card-item">
          <input className="interaction-input" data-arg='question' onChange={this.props.inputchange} name="question" placeholder={this.props.question} />
        </div>

        <p className="interaction-input-title">Add new Answer</p>
        <div className="card-item" style={{height: "150px"}} >
          <input className="interaction-input" data-arg='newchoiceanswer' onChange={this.props.inputchange} name="newchoiceanswer" placeholder={this.props.newchoiceanswer}
          />
          <label className="interaction-label" htmlFor="">
          <input className="modded-input"  onChange={this.props.selectionchange} type="checkbox" name="iscorrect" value="yes" />Correct Answer

          </label>
          <button className="add-interaction blue-button" onClick={this.handleAnswerAdd}>Add</button> 
        </div>

        <p className="interaction-input-title">Answers List</p>
        <div className="card-item-large">
        <Accordion style={{width: "100%"}}>
          {this.props.choiceanswers.map((answer, idx) => <AccordionItem key={idx} className='upcoming-activity'>
         
         <AccordionItemHeading>
                    <AccordionItemButton>
                      <p style={{marginBottom: '3px'}}>{answer.answer_text}</p>
                    </AccordionItemButton>
         </AccordionItemHeading>

         <AccordionItemPanel>
          <p style={{color: 'green'}}>Correct: <input readOnly={true} className="modded-input"  checked={answer.is_correct_answer} type="checkbox"/></p>
         </AccordionItemPanel>

         </AccordionItem>)}
         </Accordion>
        </div>

        </div>
        );
        }
    else {
      return (<div>This Interaction type is not yet available</div>);
    }
  }

  public render() {
    const { classes, theme } = this.props;

    return (
      <div className={classes.root}>
        <AppBar position="static" color="default">
          <Tabs
            value={this.state.value}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab label="Specific Options" />
            <Tab label="Interaction Settings" />
          </Tabs>
        </AppBar>
        <SwipeableViews
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={this.state.value}
          onChangeIndex={this.handleChangeIndex}
        >
          <TabContainer dir={theme.direction}>
            {this.dynamicOptions()}
          </TabContainer>

          <TabContainer dir={theme.direction}>
            <p className="interaction-input-title">Content Type:</p>
            <div className="card-item">
              <input
                className="interaction-input"
                data-arg="typecontent"
                onChange={this.props.inputchange}
                name="typecontent"
                placeholder={this.props.typecontent}
              />
            </div>

            <p className="interaction-input-title">Time Limit in seconds</p>
            <div className="card-item">
              <input
              className="interaction-input"
                data-arg="timelimit"
                type="number"
                onChange={this.props.inputchange}
                name="timelimit"
                placeholder={this.props.timelimit}
              />
            </div>

            <p className="interaction-input-title">Penalty</p>
            <div className="card-item">
              <input
              className="interaction-input"
                data-arg="penalty"
                type="number"
                onChange={this.props.inputchange}
                name="penalty"
                placeholder={this.props.penalty}
              />
            </div>

            <p className="interaction-input-title">
              Extra Time Required in seconds
            </p>
            <div className="card-item">
              <input
              className="interaction-input"
                data-arg="extratime"
                type="number"
                onChange={this.props.inputchange}
                name="extratime"
                placeholder={this.props.extratime}
              />
            </div>

            <p className="interaction-input-title">Range Min</p>
            <div className="card-item">
              <input
              className="interaction-input"
                data-arg="rangemin"
                type="number"
                onChange={this.props.inputchange}
                name="rangemin"
                placeholder={this.props.rangemin}
              />
            </div>

            <p className="interaction-input-title">Range Max</p>
            <div className="card-item">
              <input
              className="interaction-input"
                data-arg="rangemax"
                type="number"
                onChange={this.props.inputchange}
                name="rangemax"
                placeholder={this.props.rangemax}
              />
            </div>

            <p className="interaction-input-title">Min per Interaction</p>
            <div className="card-item">
              <input
              className="interaction-input"
                data-arg="minperinteraction"
                type="number"
                onChange={this.props.inputchange}
                name="minperinteraction"
                placeholder={this.props.minperinteraction}
              />
            </div>

            <p className="interaction-input-title">Max per Interaction</p>
            <div className="card-item">
              <input
              className="interaction-input"
                data-arg="maxperinteraction"
                type="number"
                onChange={this.props.inputchange}
                name="maxperinteraction"
                placeholder={this.props.maxperinteraction}
              />
            </div>

          </TabContainer>
        </SwipeableViews>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(FullWidthTabs);



// WEBPACK FOOTER //
// ./src/components/TabView/TabView.Component.tsx